import React, { useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { createLabResult, messageClean, errorClean } from "redux-store/lab-tests/tests.slice";
import { testsuccessMessage, testActivityInProcess } from "redux-store/lab-tests/tests.selecter";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import VetResult from "components/test-result-template/VetResult";
import { useReactToPrint } from "react-to-print";
import ParentResult from "components/test-result-template/ParentResult";

type Props = {
  handleClose?: any;
  open?: any;
  result?: any;
};
const PopUp = ({ handleClose, open, result }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const createMessage = useSelector(testsuccessMessage);
  const [html1, setHtml1] = useState<any>("");
  const [html2, setHtml2] = useState<any>("");
  const activity = useSelector(testActivityInProcess);

  const [riskData, setRiskData] = useState({
    resultId: result?._id,
    riskValue: 0,
    riskLevel: "",
    userId: result?.userId,
    petId: result?.petId,
    kitId: result?.kitId,
    submit: true,
    createdAt: result?.createdAt,
    updatedAt: new Date(),
  });
  const [message, setMessage] = useState({
    riskvalue: "",
    risklevel: "",
  });
  useEffect(() => {
    dispatch(messageClean());
    dispatch(errorClean());
    setHtml1("");
    setHtml2("");
  }, []);

  useEffect(() => {
    if (createMessage === "Result submitted successfully") {
      handleClose();
    }
  }, [createMessage]);

  const handleRiskVal = (e: any) => {
    let val = Number(e.target.value);
    if (e.target.value < 0.04) {
      setRiskData({
        ...riskData,
        riskLevel: "Low",
        riskValue: parseFloat(val.toFixed(3)),
      });
    } else if (e.target.value >= 0.04 && e.target.value < 0.1) {
      setRiskData({
        ...riskData,
        riskLevel: "Moderate",
        riskValue: parseFloat(val.toFixed(3)),
      });
    } else if (e.target.value >= 0.1) {
      setRiskData({
        ...riskData,
        riskLevel: "High",
        riskValue: parseFloat(val.toFixed(3)),
      });
    } else {
      setRiskData({
        ...riskData,
        riskValue: e.target.value,
      });
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (riskData.riskValue !== null && riskData.riskValue >= -0.3 && riskData.riskValue <= 0.3) {
      handlePrint();
    } else {
      setMessage({
        ...message,
        riskvalue: "Value in Range [ -0.3 to 0.3 ]",
        risklevel: "",
      });
    }
  };

  async function html2pdf1() {
    const report = {
      riskData: riskData,
      parentHtml: html1,
      vetHtml: html2,
    };

    dispatch(createLabResult(report));
  }
  useEffect(() => {
    if (html1 !== "" && html2 !== "") {
      html2pdf1();
    }
  }, [html1, html2]);

  const componentRef1 = useRef(null);
  const handlePrint = async () => {
    handlePrint1();
  };

  const handlePrint1 = useReactToPrint({
    content: () => componentRef1.current,
    documentTitle: `report.pdf`,
    print: async (printIframe: HTMLIFrameElement) => {
      // Doing what you want here, including asynchronous work
      let element1 = await printIframe.contentDocument?.getElementById("parentResult");
      setHtml1(element1?.outerHTML);

      let element2 = await printIframe.contentDocument?.getElementById("vetResult");
      setHtml2(element2?.outerHTML);
    },
  });

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{}}
      >
        <DialogTitle id="alert-dialog-title">{"Select a risk value and risk level"}</DialogTitle>
        <DialogContent>
          <div className="tw-flex tw-flex-col tw-gap-6 tw-mt-2">
            <div className="tw-relative">
              <input
                className="tw-w-full tw-rounded-lg tw-p-2 tw-border-[2px] tw-border-[#0B0B0B] focus:tw-outline-none"
                defaultValue={result?.userId?.fullName}
              />
              <label className="tw-absolute tw-left-2 tw-top-[-13px] tw-font-bold tw-bg-white">User Name</label>
            </div>
            <div className="tw-relative">
              <input
                className="tw-w-full tw-rounded-lg tw-p-2  tw-border-[2px] tw-border-[#0B0B0B] focus:tw-outline-none"
                defaultValue={result?.petId?.petName}
              />
              <label className="tw-absolute tw-left-2 tw-top-[-13px] tw-font-bold tw-bg-white">Pet Name</label>
            </div>
            <div className="tw-relative">
              <input
                className="tw-w-full tw-rounded-lg tw-p-2  tw-border-[2px] tw-border-[#0B0B0B] focus:tw-outline-none"
                onChange={handleRiskVal}
                value={riskData.riskValue !== null ? riskData.riskValue : ""}
                type="number"
              />
              <label className="tw-absolute tw-left-2 tw-top-[-13px] tw-font-bold tw-bg-white">Risk Value</label>
            </div>
            <div className="tw-flex tw-items-center">
              <div className="tw-w-full tw-flex tw-items-center tw-flex-end tw-flex-col tw-gap-2">
                <span className="tw-text-sm tw-text-red-600 tw-ml-auto">
                  {message.risklevel !== "" ? message.risklevel : message.riskvalue}
                </span>
                <button
                  className="tw-ml-auto tw-flex tw-items-center tw-py-1 tw-px-5 tw-text-white tw-font-bold tw-bg-reddishOrange tw-rounded-full"
                  onClick={handleSubmit}
                >
                  {activity ? "Submitting.." : "Submit"}
                </button>
              </div>
            </div>
          </div>
          <div id="pdf-file" className="tw-hidden" ref={componentRef1}>
            <VetResult result={riskData} />
            <ParentResult result={riskData} />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default PopUp;
